import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notifications = [{
  flagCode: 'fr',
  countryName: 'France',
  location: 'Lyon, France',
  name: 'Sophie Martin',
  initials: 'SM',
  time: 'il y a 5 minutes'
}, {
  flagCode: 'be',
  countryName: 'Belgique',
  location: 'Bruxelles, Belgique',
  name: 'Claire Vandamme',
  initials: 'CV',
  time: 'il y a 12 minutes'
}, {
  flagCode: 'ca',
  countryName: 'Québec',
  location: 'Montréal, Québec',
  name: 'Julien Roy',
  initials: 'JR',
  time: 'il y a 18 minutes'
}, {
  flagCode: 'ch',
  countryName: 'Suisse',
  location: 'Genève, Suisse',
  name: 'Camille Rochat',
  initials: 'CR',
  time: 'il y a 27 minutes'
}, {
  flagCode: 'ma',
  countryName: 'Maroc',
  location: 'Casablanca, Maroc',
  name: 'Sarah Rami',
  initials: 'SR',
  time: 'il y a 41 minutes'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-212" data-mp="ylr0xxzdypib">
      <AnimatePresence mode="wait" data-id="element-213" data-mp="3j9vp4wgwbcif">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-dark-card border border-gold/30 rounded-xl p-3.5 shadow-[0_4px_30px_rgba(212,175,55,0.25)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-214" data-mp="3jbq7q44p2sjc">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" aria-label="Fermer la notification" data-id="element-215" data-mp="31zjcburzmmqx">
              <X size={14} data-id="element-216" data-mp="2x0ylglymlff5" />
            </button>
            <div className="flex items-center gap-3" data-id="element-217" data-mp="2x1q4yyey7mp2">
              <div className="relative shrink-0" data-id="element-218" data-mp="2j0xa2ckqiplf">
                <div className="w-11 h-11 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-sm" data-id="element-219" data-mp="2j28od6bt3fqs">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`Drapeau ${current.countryName}`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-dark-card shadow" data-id="element-220" data-mp="24f9wxbcy8lc2" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-221" data-mp="28ig54ojmgml6">
                <div className="flex items-center gap-1.5 text-[11px] text-gray-400 mb-0.5" data-id="element-222" data-mp="2nct38780vpus">
                  <span className="truncate" data-id="element-223" data-mp="2ifb1b0sfaawa">{current.location}</span>
                </div>
                <p className="text-white text-[13px] leading-snug" data-id="element-224" data-mp="2w6fqta22tmsw">
                  <span className="font-bold" data-id="element-225" data-mp="2w7quzazfowkj">{current.name}</span>{' '}
                  <span className="text-gray-300" data-id="element-226" data-mp="2s4uhfyor3qng">a acheté Prof d&apos;Espagnol Prêt</span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-green-400 font-medium mt-1" data-id="element-227" data-mp="364djc9qyy5rb">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-228" data-mp="312wi2d4koha7" />
                  <ShoppingBag size={10} data-id="element-229" data-mp="3l6vf5f6kv62d" />
                  <span data-id="element-230" data-mp="3p875xo16txc5">Achat vérifié • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}